const speeds: Record<string, number> = {
    background: 0,
    stars: 0.2,
    starsNebula: 0.3,
    hazeBackground: 0,
    hazeGroup: 0,
    pinkHaze: 0,
    cloudsBack: -0.2,
    mountain: -0.05,
};

export function getLayerSpeed(name: string): number {
    return speeds[name] ?? 0;
}

export function getLayerOffset(name: string, offset: number): number {
    const speed = getLayerSpeed(name);
    return speed === 0 ? 0 : offset / (speed * 25);
}
